export interface TreatmentNote {
    content: string;
    authorId?: string;
    id: number;
    createdBy: string;
    modifiedBy?: string;
    saveToConversation: boolean;
    messageId?: string;
    isOnlyEditByBot?: boolean;
}

export interface TreatmentNoteEditModel extends Omit<TreatmentNote, 'createdBy' | 'modifiedBy'> {}
